import { render } from "./CarryWallet.vue?vue&type=template&id=0368fade"
import script from "./CarryWallet.vue?vue&type=script&lang=js"
export * from "./CarryWallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__